<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewMemberSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="$emit('clicked',false);$refs.simpleRules.reset();userData=blankUserData"
    @change="(val) => $emit('one')"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          新增學生
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        ref="simpleRules"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >

          <!-- Username -->
          <validation-provider
            #default="validationContext"
            name="Chinese Name"
            rules="required"
          >
            <b-form-group
              label="中文姓名 *"
              label-for="zh_name"
            >
              <b-form-input
                id="zh_name"
                v-model="userData.zh_name"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Email -->
          <validation-provider
            #default="validationContext"
            name="English Name"
            rules="required"
          >
            <b-form-group
              label="英文姓名 *"
              label-for="en_name"
            >
              <b-form-input
                id="en_name"
                v-model="userData.en_name"
                class="text-uppercase"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>


            <validation-provider
            #default="validationContext"
            name="mobile"
             rules="required"
          >
            <b-form-group
              label="主要聯絡手提 *"
              label-for="mobile"
            >
              <b-form-input
                id="mobile"
                v-model="userData.mobile"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>


          <validation-provider
            #default="validationContext"
            name="address"
          >
            <b-form-group
              label="地址"
              label-for="address"
            >
              <b-form-input
                id="address"
                v-model="userData.address"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

<validation-provider
              #default="validationContext"
              name="Birth"
              rules="required"
            >

              <b-form-group
                label="出生日期 *"
                label-for="birth"
                :state="getValidationState(validationContext)"
              >
                <flat-pickr
                  v-model="userData.birth"
                  class="form-control"
                  :config="{ dateFormat: 'Y-m-d'}"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Gender"
            rules="required"
          >
            <b-form-group
              label="性別 *"
              label-for="gender"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="userData.gender"
                :options="genderOptions"
                :clearable="false"
                :reduce="val => val.value"
                input-id="gender"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="School Grade"
            rules="required"
          >
            <b-form-group
              label="在學級別 *"
              label-for="school_grade"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="userData.school_grade"
                :options="schoolGradeOptions"
                :clearable="false"
                :reduce="val => val.value"
                input-id="school_grade"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="Rainbow Grade"
            rules="required"
          >
            <b-form-group
              label="Rainbow級別 *"
              label-for="rainbow_grade"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="userData.grade"
                :options="gradeOptions"
                :clearable="false"
                input-id="rainbow_grade"
                :reduce="val => val.code"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Country -->
         <!-- <validation-provider
            #default="validationContext"
            name="Status"
            rules="required"
          >
            <b-form-group
              label="Status"
              label-for="status"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="userData.status"
                :options="statusOptions"
                :clearable="false"
                input-id="status"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
-->
          <!-- Form Actions -->
          <div class="d-flex mt-2 mb-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="button"
              :disabled="processing"
              @click="submit_now()"
            >
              確定
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              取消
            </b-button>
          </div>
            <br><br><br><br><br><br><br>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import countries from '@/@fake-db/data/other/countries'

export default {
  components: {
    ToastificationContent,
    flatPickr,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewMemberSidebarActive',
    event: 'update:is-add-new-Member-sidebar-active',
  },
  props: {
    isAddNewMemberSidebarActive: {
      type: Boolean,
      required: true,
    },
    genderOptions: {
      type: Array,
      required: true,
    },
    planOptions: {
      type: Array,
      required: true,
    },

    statusOptions: {
      type: Array,
      required: true,
    },
    centerOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      required,
      processing: false,
      alphaNum,
      email,
      countries,
      blankUserData: {
        display_name: '',
        status: '',
      },
      schoolGradeOptions: [
        { label: 'N', value: 'N' },
        { label: 'K1', value: 'K1' },
        { label: 'K2', value: 'K2' },
        { label: 'K3', value: 'K3' },
        { label: 'P1', value: 'P1' },
        { label: 'P2', value: 'P2' },
        { label: 'P3', value: 'P3' },
        { label: 'P4', value: 'P4' },
        { label: 'P5', value: 'P5' },
        { label: 'P6', value: 'P6' },
        { label: 'S1', value: 'S1' },
        { label: 'S2', value: 'S2' },
        { label: 'S3', value: 'S3' },
        { label: 'S4', value: 'S4' },
        { label: 'S5', value: 'S5' },
        { label: 'S6', value: 'S6' },
        { label: 'ADULT', value: 'ADULT' }
      ],
      gradeOptions: [
      ],
    }
  },
  created() {
    this.get_grade()
  },
  methods: {
    get_grade() {
      this.$http.get(process.env.VUE_APP_API_BASE + '/grades/')
        .then(res => {
          this.gradeOptions = res.data.grades
        })
    },
    resetForm() {

    },
    submit_now() {
      this.processing = true
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.userData.center_id =  this.$store.getters['center/currentCenterId']
          this.$http.post(process.env.VUE_APP_API_BASE+'/student/add/', this.userData)
            .then(res => {
              if (res.data.result === true) {
                this.$emit('clicked', false)
                this.userData = this.blankUserData
                this.$refs.simpleRules.reset()
                this.processing = false
              } else {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-center',
                  props: {
                    title: 'Error',
                    icon: 'XIcon',
                    variant: 'danger',
                    text: res.data.message,
                  },
                })
                this.processing = false
              }
            })
        }
      })
    },
  },
  setup(props, { emit }) {
    const blankUserData = {
      status: 'ACTIVE',
    }

    const userData = ref(JSON.parse(JSON.stringify(blankUserData)))
    const resetuserData = () => {
      userData.value = JSON.parse(JSON.stringify(blankUserData))
    }

    const onSubmit = () => {

    }

    const {
      refFormObserver,
      getValidationState,
    } = formValidation(resetuserData)

    return {
      userData,
      onSubmit,

      refFormObserver,
      getValidationState,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
